<script>
    import ContentLoader from 'svelte-content-loader';
</script>

<ContentLoader height={400}>
    <rect x="26" y="276" rx="0" ry="0" width="200" height="43" /> 
    <circle cx="126" cy="147" r="102" />
</ContentLoader>
